import {equipmentOidTypes} from '@/components/mixins/ConversionMixin'

export default class VelhoRoadsideAdvertisementModel {
    // Private properties
    /** @type {string} */
    _external_system_id = equipmentOidTypes.EXTERNAL_ROADSIDE_ADVERTISEMENTS

    constructor(
        material = null, lighting = null, condition = null, position = { x: null, y: null }, roadNum = null, roadSec = null, distance = null, digitalImageNumber = null,
        distanceFromRoad = null, code = "", equipmentDamages = [], locationDeviation = null, locationSpecification = { lane: [], side: null, tracks: null, central_area: null }, externalSystemId = ""
    ) {
        /** @type {number | null} */
        this.material = material

        /** @type {number | null} */
        this.lighting = lighting

        /** @type {number | null} */
        this.condition = condition

        /** @type {{ x: number, y: number }} */
        this.position = position

        /** @type {number | null} */
        this.road_num = roadNum

        /** @type {number | null} */
        this.road_sec = roadSec

        /** @type {number | null} */
        this.distance = distance

        /** @type {number | null} */
        this.digital_image_number = digitalImageNumber

        /** @type {number | null} */
        this.distance_from_road = distanceFromRoad

        /** @type {string} */
        this.code = code

        /** @type {Array} */
        this.equipment_damages = equipmentDamages

        /** @type {number | null} */
        this.location_deviation = locationDeviation

        /** @type {{ lane: number[], side: number | null, tracks: number | null, central_area: number | null }} */
        this.location_specification = locationSpecification

        if(externalSystemId) {
            this._external_system_id = externalSystemId
        }
    }

    /**
    * Gets the unique identifier.
    * @returns {string}
    */
    get external_system_id() {
        return this._external_system_id
    }

    /**
    * Get the culvert json object.
    * @returns {object}
    */
    toJSON() {
        return JSON.parse(
            JSON.stringify({
            external_system_id: this._external_system_id,
            material: this.material,
            lighting: this.lighting,
            condition: this.condition,
            position: this.position,
            road_num: this.road_num,
            road_sec: this.road_sec,
            distance: this.distance,
            digital_image_number: this.digital_image_number,
            distance_from_road: this.distance_from_road,
            code: this.code,
            equipment_damages: this.equipment_damages,
            location_deviation: this.location_deviation,
            location_specification: {
                ...this.location_specification,
                tracks: this.location_specification.tracks !== null ? [this.location_specification.tracks] : []
            }
        }))
    }

    /**
    * Create default instance with position data.
    * @param {{ x: number, y: number }} position - coordinates.
    * @param {number | null} roadNum - Road number.
    * @param {number | null} roadSec - road section.
    * @param {number | null} distance - distance (road geometry).
    * @returns {VelhoRoadsideAdvertisementModel}
    */
    static instanceWithPosition(position, roadNum, roadSec, distance) {
        const instance = new VelhoRoadsideAdvertisementModel()
        instance.position = position
        instance.road_num = roadNum
        instance.road_sec = roadSec
        instance.distance = distance
        return instance
    }
}
